export default "<p>user-admin works!</p>\n"